import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/halo-query/components/home.tsx");
